import { combineReducers, Store, createStore as reduxCreateStore } from "redux";
import { Action } from "./typedActions";

const createStore = require<typeof reduxCreateStore>('./createStore');

interface Reducer<State> {
    (state: State, action: Action<any>): State;
}

interface Reducers {
    [name: string]: Reducer<any>;
}

export default class StoreProvider {
    private reducer: Reducer<{}>;
    private reducers: Reducers;
    private store: Store;

    constructor() {
        this.reducers = {};
        // use just an identity reducer for the start
        this.reducer = state => state;
        this.store = createStore(this.reducer);
    }

    addReducer<S>(reducer: Reducer<S>, namespace: string) {
        if (this.reducers.hasOwnProperty(namespace)) {
            throw new Error(`reducer for ${namespace} already defined`);
        } else {
            this.reducers[namespace] = reducer;
        }
        this._recomposeReducer();
    }

    removeReducer<S>(reducer: Reducer<S>, namespace: string) {
        if (!this.reducers.hasOwnProperty(namespace)) {
            throw new Error(`reducer for ${namespace} not found`);
        } else if (this.reducers[namespace] !== reducer) {
            throw new Error(`reducer for ${namespace} is different than the one provided`);
        } else {
            delete this.reducers[namespace];
        }
        this._recomposeReducer();
    }

    getStore() {
        return this.store;
    }
    // TODO extract this from class and make it separate
    watchStore<S>(selector: (appState: any) => S, handler: (state: S, prevState: S) => void) {
        let currentState: S = selector(this.store.getState());

        const stateChangeHandler = () => {
            let previousState = currentState;
            currentState = selector(this.store.getState());

            if (previousState !== currentState) {
                handler(currentState, previousState);
            }
        };
        this.store.subscribe(stateChangeHandler);
    }

    private _recomposeReducer() {
        this.reducer = combineReducers(this.reducers);
        this.store.replaceReducer(this.reducer);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/redux/StoreProvider.ts
 **/